export default __webpack_public_path__ + "ba989d64faa604a9c4f2f37b831dff2d.jpg";